var _Path, _Polyline, _Line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, Polyline, Line } from "react-native-svg";
var SvgLogIn = function SvgLogIn(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-log-in"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
  })), _Polyline || (_Polyline = /*#__PURE__*/React.createElement(Polyline, {
    points: "10 17 15 12 10 7"
  })), _Line || (_Line = /*#__PURE__*/React.createElement(Line, {
    x1: 15,
    y1: 12,
    x2: 3,
    y2: 12
  })));
};
export default SvgLogIn;